const parseJSON = (str) => {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return null;
    }
};

export { parseJSON as default };
//# sourceMappingURL=parseJSON.js.map
